import React from 'react';
import withStyles from '@material-ui/core/styles/withStyles';
import PropTypes from 'prop-types';
import Typography from '@material-ui/core/Typography/Typography';
import { Button } from '@material-ui/core';
import clsx from 'clsx';

const TextBox = ({
  classes,
  title,
  children,
  linktext,
  link,
  href,
  className,
  props,
}) => (
  <div className={clsx(className)}>
    <div className={classes.container}>
      <Typography variant="h6">{title}</Typography>
      {children}
      {linktext && <Button href={link ? `#${link}` : href} size="small" className={classes.button} {...props}>{linktext}</Button>}
    </div>
  </div>
);

TextBox.propTypes = {
  classes: PropTypes.object.isRequired,
  title: PropTypes.any,
  children: PropTypes.any,
  linktext: PropTypes.any,
  link: PropTypes.any,
  href: PropTypes.any,
  className: PropTypes.string,
  props: PropTypes.any,
};

TextBox.defaultProps = {
  title: '',
  children: '',
  linktext: '',
  link: '',
  href: '',
  className: undefined,
  props: null,
};

TextBox.propComments = {
  title: 'Title in textbox.',
  children: 'Any content inside textbox. Often used with Material UI Typography component for displaying text.',
  linktext: 'Text describing button.',
  link: 'Link for internal site. A "#" will be added to the beginning.',
  href: 'Link for external site.',
  className: 'Custom styling for outer div.',
  props: 'Other props added to the Button Material UI Component.',
};


const styles = theme => ({
  container: {
    padding: '1.3rem',
    backgroundColor: '#EBF2F8',
  },
  button: {
    marginLeft: '-0.4rem',
    color: theme.palette.primary.main,
  },
});

export default withStyles(styles)(TextBox);
